__turbopack_context__.v({
  "active": "Chart-module__QzsKoq__active",
  "boxChartContainer": "Chart-module__QzsKoq__boxChartContainer",
  "boxContentDate": "Chart-module__QzsKoq__boxContentDate",
  "chartNav": "Chart-module__QzsKoq__chartNav",
  "chartNavItem": "Chart-module__QzsKoq__chartNavItem",
  "chartTab": "Chart-module__QzsKoq__chartTab",
  "chartTabLongName": "Chart-module__QzsKoq__chartTabLongName",
  "chartTabShortName": "Chart-module__QzsKoq__chartTabShortName",
  "disabled": "Chart-module__QzsKoq__disabled",
  "error": "Chart-module__QzsKoq__error",
});
